import type {
    PublicKeyCredentialRequestOptionsJSON,
    SerializedAssertionCredential,
} from './webauthn';

type GetPasskeyAssertion = (
    options: PublicKeyCredentialRequestOptionsJSON,
) => Promise<SerializedAssertionCredential>;

export async function getPasskeyAssertionWithFriendlyError(
    getAssertion: GetPasskeyAssertion,
    options: PublicKeyCredentialRequestOptionsJSON,
): Promise<SerializedAssertionCredential> {
    try {
        return await getAssertion(options);
    } catch (error) {
        if (
            typeof error === 'object' &&
            error !== null &&
            'name' in error &&
            error.name === 'NotAllowedError'
        ) {
            throw new Error(
                'No passkey was selected on this device. Try again, or sign in with Connected Wallet.',
            );
        }
        throw error;
    }
}
